<template>
  <div class="card shadow-sm">
    <div class="d-flex w-100 p-3 justify-content-between mt-1 border-bottom position-relative card-title-ido">
      <h5 class="fw-bold text-primary">预约信息</h5>
      <a href="#" class="card-link text-primary" @click="more">更多</a>
    </div>
    <div class="list-box mt-2 d-flex align-items-center justify-content-center" v-if="loading || (!loading && list.length<=0)">
      <!-- loading-->
      <div v-if="loading"  class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <!--              暂无数据-->
      <div v-if="!loading && list.length<=0" class="text-secondary fw-bold" role="status">
        <span >暂无数据</span>
      </div>
    </div>
    <div class="list-box mt-2" v-else>
      <div class="py-2 px-2 flex-shrink-0  m-1 item-box border-bottom" v-for="(item,index) of list" :key="index">
        <div class="justify-content-between d-flex  ">
          <div class=" point-curser list-des fw-medium" @click="goDetail(item)">
            {{ item.Device?item.Device.Name?item.Device.Name:"设备名称未知":"设备名称未知" }}
          </div>
          <div class="  list-time ">
            <span class="badge text-bg-primary text-white  rounded-pill">已预约</span></div>
        </div>
        <div class="justify-content-between d-flex mt-1">
          <div class="point-curser list-sec-l text-body-secondary">
            累计预约 <span class="text-primary">{{ item.Device?item.Device.TotalAppointment?item.Device.TotalAppointment:"0":"0" }}</span> 次
          </div>
          <div class="text-body-secondary  list-sec-r ">预约时间：{{ item.StartTimeDeal }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {onMounted, ref,computed,defineProps} from "vue";
import router from "@/router";
import {useStore} from 'vuex'
const store = useStore()
const list = computed(()=> store.state.homeModel.appointment)//预约信息
defineProps({
  loading:{
    default:true
  }
})
const more = () => {
  router.push({path: '/equipmentsharing'})
}
const goDetail = (item)=>{
  router.push({path:'/equipmentDetail',query:{id:item.ID}})

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/assets/css/FirstPageListStyle.scss";

.list-sec-l {
  width: 0;
  flex: 1;
  height: 1.1rem;
  line-height: 1.1rem;
  text-align: left;
  word-break: break-all;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  box-sizing: border-box;
  padding-left: 0.5rem;
  font-size: 0.8rem;
}

.list-sec-r {
  flex-shrink: 0;
  width: 50%;
  font-size: 0.8rem;
  height: 1.1rem;
  line-height: 1.1rem;
  word-break: break-all;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  box-sizing: border-box;
  text-align: right;
}

.border-bottom:last-child {
  border: none !important;
}
</style>
